// extracted by mini-css-extract-plugin
module.exports = {"nav":"SideNavBar_nav__AO11F"};